import { ISpinButtonStyles } from "@fluentui/react/lib/SpinButton";
import { concatStyleSets } from "@fluentui/react/lib/Styling";
import { memoizeFunction } from "@fluentui/react/lib/Utilities";

import { controlStylingConstants } from "@1js/acui-common";

export const getSpinButtonStylesInMenu = memoizeFunction(
  (customStyles?: Partial<ISpinButtonStyles>): Partial<ISpinButtonStyles> => {
    return concatStyleSets(
      {
        root: {
          height: controlStylingConstants.menuItemHeight,
          margin: `0 ${controlStylingConstants.menuItemGapToRightEdge}px 0 0`,
        },
      },
      customStyles
    );
  }
);

export const getSpinButtonStylesInMLRMenu = memoizeFunction(
  (customStyles?: Partial<ISpinButtonStyles>): Partial<ISpinButtonStyles> => {
    return concatStyleSets(
      {
        root: {
          height: controlStylingConstants.smallMenuItemHeight,
          margin: `0 ${controlStylingConstants.menuItemGapToRightEdge}px 0 0`,
        },
        labelWrapper: {
          marginRight: 20,
        },
      },
      customStyles
    );
  }
);
